import { Loader } from '@googlemaps/js-api-loader';
import { decode } from './queryEncryption';


export const googleMapLoader = async (googleMapBrowserApiKey) => {
    const loader = new Loader({
        apiKey: decode(googleMapBrowserApiKey),
        libraries: ['places'],
    });
    try {
        await loader.importLibrary('places');
    } catch (error) {
        console.error(error);
    }
}